module.exports = __webpack_public_path__ + "media/images/lb/398-4c153cc251102237bb2b79c7dfb9b81f.svg";